import inflection from "inflection";
import { Component } from "preact";
import csstyle from "tpm-lib/widgets/csstyle.js";

export default class Widget extends Component {
	get widgetName() {
		return inflection.camelize(this.constructor.typeName);
	}

	get refs() {
		const _refs = {};
		Object.defineProperty(this, "refs", {
			get() {
				return _refs;
			},
		});
		return _refs;
	}

	getBaseProps() {
		return {
			className: this.componentClasses(),
			ref: (x) => (this.refs.base = x),
		};
	}

	componentClasses(name) {
		const base = csstyle(name || this.widgetName);
		const extra = this.props.cssclasses;
		return extra ? `${base} ${extra}` : base;
	}


	render(props, state) {
		return (
			<div {...this.getBaseProps()}>{this.renderContent(props, state)}</div>
		);
	}

	// static row(...grids) {
	// 	return <div className="row">{grids}</div>;
	// }

	// static row({ children, cols, ...props }) {
	// 	const rowClass = cols ? `row-${cols}` : "row";
	// 	props.className = props.className || "";
	// 	props.className = `${props.className}${props.className && " "}${rowClass}`;
	// 	props.className += "";
	// 	return <div {...props}>{children}</div>;
	// }
}
